import './pageTitle.scss';

import React from 'react';

export default function PageTitle(props: {
    title: string;
    description?: string;
    children?: any;
    notHeader?: boolean;
}) {
    const { title, description, children, notHeader } = props;
    return (
        <div className='page-header'>
            <div className='page-title'>
                {notHeader ? <h2>{title}</h2> : <h1>{title}</h1>}
            </div>
            <div className='desc'>
                {description && description.length && (
                    <div className='content'>{description}</div>
                )}
                {children}
            </div>
        </div>
    );
}
